import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import placeholder from "../../assets/images/userprofile.png";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Container, Row, Col, Form } from "react-bootstrap";
import { blobToFile } from "../../utils/helpers";
import ImageCropper from "../../Component/ImageCropper/resourceHub";
import PopupModalWithOk from "../../utils/helpers/popupModalOk";
import { postResourcesHubData } from "./Slice/resourcesHubSlice";
import PropTypes from "prop-types";

const Index = (props) => {

  const dispatch = useDispatch();
  const { title, superUserParams } = props;
  const userInfo = useSelector((state) => state.userInfo || {});
  const getUserId = localStorage.getItem("userId");
  const { register, handleSubmit, setValue, formState: { errors } } = useForm({ defaultValues: superUserParams });
  const [{ alt, src }, setImg] = useState({ src: '', alt: "Image size should be less than 2 MB" });
  const [popupMessage, setPopupMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitSuccess, setIsSubmitSuccess] = useState(false);

  useEffect(() => {
    document.title = title;
    register("description");
  }, [title]);

  const history = useNavigate();

  const onSubmit = async (data) => {
    setIsSubmitting(true);

    // Check if image is selected
    if (!selectedFile?.name) {
      setIsSubmitSuccess(false);
      setPopupMessage("Please select an image");
      setShowPopup(true);
      setIsSubmitting(false);
      return;
    }

    const formData = new FormData();
    if (data.category_id) formData.append("category_id", data.category_id);
    if (data.title) formData.append("title", data.title);
    formData.append("user_id", userInfo?.id);
    if (data.description) formData.append("description", data.description);
    if (selectedFile.name) formData.append("image", selectedFile);

    try {
      const result = await dispatch(postResourcesHubData(formData)).unwrap();
      const status = result?.payload?.status ?? result?.status;
      const message = result?.payload?.message || result?.message || "Post created successfully!";

      setIsSubmitSuccess(status === 200);
      setPopupMessage(message);
      setShowPopup(true);

      if (status !== 200) {
        return;
      }
    } catch (error) {
      setIsSubmitSuccess(false);
      const errorMessage = error?.response?.data?.message || "Failed to create resource. Please try again.";
      setPopupMessage(errorMessage);
      setShowPopup(true);
    } finally {
      setIsSubmitting(false);
    }
  };
  

  const handleResourcePopupClose = () => {
    setShowPopup(false);
    if (isSubmitSuccess) {
      history("/resource-hub/all-posts");
    }
  };

  const [cropImg, setCropImg] = useState("");
  const [cropImgModalShow, setCropImgModalShow] = useState(false);

  /* File upload */
  const [selectedFile, setSelectedFile] = useState("");
  const onChangePicture = (e) => {
    const file = e.target.files?.[0];

    // No file selected
    if (!file) {
      setIsSubmitSuccess(false);
      setImg({
        src: "",
        alt: "Image size should be less than 2 MB",
      });
      return;
    }

    const sizeInMB = file.size / (1024 * 1024);

    // Size validation
    if (sizeInMB > 2) {
      alert("Please select image size less than 2 MB");
      setImg({
        src: "",
        alt: "Image size should be less than 2 MB",
      });
      return;
    }

    // File type validation
    const isValidImage = /\.(jpg|jpeg|png)$/i.test(file.name);
    if (!isValidImage) {
      setIsSubmitSuccess(false);
      setPopupMessage("Please select a valid image.");
      setShowPopup(true);
      setImg({
        src: placeholder,
        alt: "Upload an Image",
      });
      return;
    }

    // Valid image → open crop modal
    const cropImageUrl = URL.createObjectURL(file);
    setCropImg(cropImageUrl);
    setCropImgModalShow(true);
  };


  const fileToImage = (childdata) => {
    setSelectedFile(blobToFile(childdata, getUserId + '.png'));
    setImg({
      src: URL.createObjectURL(childdata),
      alt: '',
    });
    setCropImgModalShow(false); // Close the modal after cropping
  }

  return (
    <>
      <section className="loginouter">
        <Container>
          <Row className="align-items-center ">
            <Col md={12}>
              <div className="logininnerouter">
                <div>
                  <div className="loginform" style={{ width: `100%` }}>
                    <h1>Post Resources</h1>
                    <Form onSubmit={(e) => { e.preventDefault(); handleSubmit(onSubmit)(e); }}>
                      <Row>
                        <Col md="12">
                          <div className="form-group mb-3">
                            <select
                              name="category_id"
                              {...register("category_id", {
                                required: "select one category",
                              })}
                              className={
                                errors?.category_id
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                            >
                              <option value="">Please Select Category*</option>
                              <option value="1">People Stories</option>
                              <option value="2">Points of view</option>
                              <option value="3">Toolkits</option>
                            </select>
                            {errors?.category_id && (
                              <label className="invalid-feedback text-left" htmlFor="category">
                                Please select one option
                              </label>
                            )}
                          </div>
                        </Col>

                        <Col md={12}>
                          <div className="form-group mb-3">
                            <Form.Control
                              type="text"
                              placeholder="Title*"
                              className={
                                errors?.title
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              name="title"
                              aria-invalid={errors?.title ? "true" : "false"}
                              {...register("title", {
                                required: true,
                                minLength: 3,
                                maxLength: 250,
                              })}
                            />
                            {errors?.title &&
                              errors?.title.type === "required" && (
                                <label className="invalid-feedback text-left" htmlFor="title">
                                  Please enter title
                                </label>
                              )}
                            {errors?.title &&
                              errors?.title.type === "minLength" && (
                                <label className="invalid-feedback text-left" htmlFor="title">
                                  Your platform title should contain at least
                                  3 characters
                                </label>
                              )}
                            {errors?.title &&
                              errors?.title.type === "maxLength" && (
                                <label className="invalid-feedback text-left" htmlFor="title">
                                  Your title should contain max 20
                                  characters
                                </label>
                              )}
                          </div>
                        </Col>
                        <Col md={12}>
                          <div className="form-group mb-3">
                            <div className="userprofile pt-3 pb-5">

                              <div>
                                <span className="inputfileouter">
                                  Upload image{" "}
                                  <input
                                    type="file"
                                    accept=".png, .jpg, .jpeg"
                                    onChange={onChangePicture}
                                    className="form-control"
                                    name="image"
                                  // Remove react-hook-form registration to prevent conflict
                                  />
                                </span>
                                {src && (
                                  <>
                                    <br />
                                    <br />
                                    <img
                                      className="img-fluid"
                                      src={src}
                                      alt={alt}
                                    />
                                  </>
                                )}
                                <span style={{ padding: `12px`, color: `black` }}>{alt}</span>

                                {!selectedFile && (
                                  <label className="customeValidationText text-left" htmlFor="image">
                                    Please select an image
                                  </label>
                                )}
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col md={12}>

                          <Form.Group controlId="formBasicdescription">
                            <Form.Label style={{ color: `black` }}>Note : If  you are copying and pasting your content,
                              you may like to enable the source code before so that you can format the content
                              as you wish. Please disable the source code once done and then click the submit button.</Form.Label>

                            <CKEditor
                              editor={ClassicEditor}
                              config={{
                                toolbar: [
                                  'heading', '|',
                                  'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|',
                                  'outdent', 'indent', '|',
                                  'blockQuote', 'insertTable', 'undo', 'redo'
                                ]
                              }}
                              onChange={(event, editor) => {
                                const data = editor.getData();
                                setValue("description", data);
                              }}
                            />
                            {errors?.description && errors?.description.type === "required" && (
                              <label className="invalid-feedback text-left" htmlFor="description">
                                Please enter your description
                              </label>
                            )}
                          </Form.Group>
                        </Col>

                        <Col md={12}>
                          <div className="form-group mt-3">
                            <button
                              type="submit"
                              className="btn loginsubmit nextbtn ml-2"
                              disabled={isSubmitting}
                            >
                              {isSubmitting ? (
                                <>
                                  <span className="spinner-border spinner-border-sm me-2" aria-hidden="true" />{" "}
                                  Submitting...
                                </>
                              ) : (
                                "Submit"
                              )}
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      {cropImgModalShow && (
        <ImageCropper
          show={true}
          cropImg={cropImg}
          fileToImage={fileToImage}
          onHide={() => {
            setCropImgModalShow(false);
          }}
          centered={true}
          size="xl"
          className="cropper-modal"
          style={{ zIndex: 9999 }}
        />
      )}

      <PopupModalWithOk
        show={showPopup}
        onHide={handleResourcePopupClose}
        message={popupMessage}
        showConfirm={false}
        staticBackdrop={true}
      />

    </>
  );
};

Index.propTypes = {
  title: PropTypes.string.isRequired,
  superUserParams: PropTypes.object.isRequired,
};

export default Index;
